export default __webpack_public_path__ + "static/media/Group 12505.1fa9be45.svg";